import { calgaryDateString } from '../../../../../../../utils/calgaryTime';
import React, { useState, useRef, useEffect } from "react";
import styles from "./BillableTimeForm.module.css";
import FormEntryMultilineTextbox from '@frontend/Components/Forms/Entry/MultilineTextbox/FormEntryMultilineTextbox';

const BillableTimeForm = ({ onSubmit, employee, setShowAddForm, matterId }) => {
  const [timeRecorded, setTimeRecorded] = useState("");
  const [date, setDate] = useState(calgaryDateString());
  const [notes, setNotes] = useState("");
  const [error, setError] = useState("");

  const modalRef = useRef(null); // Modal reference to check if the click was outside the modal

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowAddForm(false); // Close modal
      }
    };

    // Bind the click event
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowAddForm]);

  // Format time to HH:MM:SS
  const formatTimeRecorded = (time) => {
    const totalMinutes = parseFloat(time) * 60;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.floor(totalMinutes % 60);
    return `${hours < 10 ? "0" + hours : hours}:${
      minutes < 10 ? "0" + minutes : minutes
    }:00`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!employee) {
      console.error("Employee data is not available.");
      setError("Employee data is missing.");
      return;
    }

    const formattedTime = formatTimeRecorded(timeRecorded);

    if (!formattedTime) {
      console.error("Invalid time recorded.");
      setError("Invalid input data.");
      return;
    }

    const formData = {
      time_recorded: formattedTime,
      date_recorded: date,
      notes,
      employeeid: employee.employeeid,
      matterid: matterId,
    };

    onSubmit(formData);
    setShowAddForm(false);
  };

  return (
    <div className={styles["Fixed-fees-overlay"]}>
      <div className={styles["Fixed-fees-modal"]} ref={modalRef}>
        <div className={styles["title-button-container"]}>
          <h2>Add Billable Time</h2>
        </div>
        {error && <p className="error-message">{error}</p>}
        <form className={styles["new-fee-form"]} onSubmit={handleSubmit}>
          <input
            type="number"
            className="input-field"
            placeholder="Enter time recorded (in hours)"
            value={timeRecorded}
            onChange={(e) => setTimeRecorded(e.target.value)}
            required
          />
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
          <FormEntryMultilineTextbox
            className={styles["billable-time-textarea"]}
            name="notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Type notes here"
            rows={3}
          />
          <button type="submit" className={styles["submit-fee-button"]}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default BillableTimeForm;
